// this file is generated by update_shopify_store_data.py at 2026-02-23 20:27:01.784320
var courses = [
    {
        "course_id": "10C68D87-4D99-EB11-80E0-005056B1202E",
        "course_version": 4,
        "name": "AWHONN NOEP - Module 01 - Families in Crisis",
        "course_type": 1,
        "author_information": "The Neonatal Orientation and Education Program (NOEP) was published through the coordinated efforts of a team of dedicated AWHONN members and staff. Disclosures:\u202fNo commercial support or sponsorship was received for this presentation. The AWHONN nurse planner, contributors, and reviewers report no relevant financial or commercial conflicts related to this educational activity.",
        "description": "The purpose of this module is to provide an understanding of the significant issues that nurses and parents face together in the Neonatal Intensive Care Unit (NICU) environment. Although many neonates are born very healthy, a percentage will have difficulty transitioning from intrauterine to extrauterine life. An admission to the NICU due to congenital anomalies, critical illness, instability, or life threatening disease can pose significant stress on the family and nurses caring for the neonate.",
        "learning_objectives_html": "At the completion of Module 01 the learner will be able to:\r\n<ul>\r\n    <li>Prepare the NICU nurse for the impact that families in crisis can have on them and how the NICU nurse can impact the families in crisis.</li>\r\n    <li>Consider the steps in parent-newborn attachment to promote feelings of responsibility and nurturing.</li>\r\n    <li>Identify the needs and provide trauma-informed care for the traditional and nontraditional families in crisis.</li>\r\n    <li>Formulate nursing interventions to support a family coping with a crisis or perinatal loss and grief.<br />\r\n    <div>&nbsp;</div>\r\n    </li>\r\n</ul>",
        "course_outline_html": "Please refer to your administrator for course outlines.",
        "credit_info": "-",
        "categories": [
            {
                "course_category_id": "1F4B1A8B-1EC9-E511-8771-005056B104B1",
                "course_category_name": "Nurse Midwife",
                "is_system_course_category": null
            },
            {
                "course_category_id": "33607431-5FF9-E611-B748-005056B122EA",
                "course_category_name": "Maternal Newborn",
                "is_system_course_category": null
            },
            {
                "course_category_id": "E24BC24C-40B4-DF11-9F38-0015171C5BB1",
                "course_category_name": "CNE - Continuing Nurse Education",
                "is_system_course_category": null
            },
            {
                "course_category_id": "4F027BAC-08C9-E511-8771-005056B104B1",
                "course_category_name": "Clinical Nurse Specialist",
                "is_system_course_category": null
            },
            {
                "course_category_id": "BF92C7B7-00C9-E511-BC00-005056B1263C",
                "course_category_name": "Ambulatory Care",
                "is_system_course_category": null
            },
            {
                "course_category_id": "1D5C5A97-08DB-E511-AA9E-005056B17E48",
                "course_category_name": "Women's Health",
                "is_system_course_category": null
            },
            {
                "course_category_id": "EE2F1978-C2F1-E311-941D-005056B1522B",
                "course_category_name": "AWHONN - Association of Women's Health, Obstetric, and Neonatal Nurses",
                "is_system_course_category": null
            },
            {
                "course_category_id": "4D1B82BB-02C9-E511-8771-005056B104B1",
                "course_category_name": "Acute Care Facility",
                "is_system_course_category": null
            },
            {
                "course_category_id": "0DFB1B0D-04C9-E511-8771-005056B104B1",
                "course_category_name": "Allied Health Professional",
                "is_system_course_category": null
            },
            {
                "course_category_id": "F7C94142-A78D-EB11-80DF-005056B1202E",
                "course_category_name": "AWHONN - AWHONN NOEP Library (Resources in separate folder)",
                "is_system_course_category": null
            },
            {
                "course_category_id": "43D048A0-1EC9-E511-8771-005056B104B1",
                "course_category_name": "Nurse",
                "is_system_course_category": null
            },
            {
                "course_category_id": "2FA45D8A-264F-DB11-9011-000423ACEF71",
                "course_category_name": "Obstetrics and Gynecology",
                "is_system_course_category": null
            },
            {
                "course_category_id": "897AA72F-A78D-EB11-80DF-005056B1202E",
                "course_category_name": "AWHONN NOEP Library",
                "is_system_course_category": null
            }
        ],
        "ce_accreditation": {
            "accrediting_body_name": "ANCC",
            "accreditation_statement": "",
            "course_level_accreditation_statement": "The Association of Women&rsquo;s Health, Obstetric and Neonatal Nurses is accredited as a provider of nursing continuing professional development by the American Nurses Credentialing Center&rsquo;s Commission on Accreditation. Accredited status does not imply endorsement by AWHONN or ANCC of any commercial products discussed/displayed in conjunction with the educational activity. AWHONN is approved by the California Board of Registered Nursing, Provider #CEP580.",
            "credit_display_name": "ANCC CNE Credit",
            "credit_units": 2.25,
            "credit_unit_display_name": "ANCC Contact\r\nHour(s)"
        },
        "sub_courses": []
    },
    {
        "course_id": "3ACF5749-A18D-EB11-80DF-005056B1202E",
        "course_version": 4,
        "name": "AWHONN NOEP - Module 02 - Transition to Extrauterine Life",
        "course_type": 1,
        "author_information": "The Neonatal Orientation and Education Program (NOEP) was published through the coordinated efforts of a team of dedicated AWHONN members and staff. Disclosures:\u202fNo commercial support or sponsorship was received for this presentation. The AWHONN nurse planner, contributors, and reviewers report no relevant financial or commercial conflicts related to this educational activity.",
        "description": "The purpose of this module is to provide an overview of the physiologic adaptation of the fetus to extrauterine life. It begins by briefly reviewing conditions that may be present during the preconception, antepartum, and intrapartum periods that may negatively impact a newborn\u2019s ability to successfully transition. Physiologic changes that occur during transition from fetal to neonatal life will be identified, as well as signs and symptoms of common problems.",
        "learning_objectives_html": "At the completion of Module 02 the learner will be able to:\r\n<ul>\r\n    <li>Identify preconception, antepartum, and intrapartum conditions that may result in complications for the newborn.<span style=\"white-space: pre;\">\t\t</span></li>\r\n    <li>Identify physiologic changes that occur during transition to extrauterine life.<span style=\"white-space: pre;\">\t\t</span></li>\r\n    <li>Review signs and symptoms of common problems during the transition period.<span style=\"white-space: pre;\">\t</span><br />\r\n    <div>&nbsp;</div>\r\n    </li>\r\n</ul>",
        "course_outline_html": "Please refer to your administrator for course outlines.",
        "credit_info": "-",
        "categories": [
            {
                "course_category_id": "43D048A0-1EC9-E511-8771-005056B104B1",
                "course_category_name": "Nurse",
                "is_system_course_category": null
            },
            {
                "course_category_id": "4D1B82BB-02C9-E511-8771-005056B104B1",
                "course_category_name": "Acute Care Facility",
                "is_system_course_category": null
            },
            {
                "course_category_id": "2FA45D8A-264F-DB11-9011-000423ACEF71",
                "course_category_name": "Obstetrics and Gynecology",
                "is_system_course_category": null
            },
            {
                "course_category_id": "897AA72F-A78D-EB11-80DF-005056B1202E",
                "course_category_name": "AWHONN NOEP Library",
                "is_system_course_category": null
            },
            {
                "course_category_id": "F7C94142-A78D-EB11-80DF-005056B1202E",
                "course_category_name": "AWHONN - AWHONN NOEP Library (Resources in separate folder)",
                "is_system_course_category": null
            },
            {
                "course_category_id": "0DFB1B0D-04C9-E511-8771-005056B104B1",
                "course_category_name": "Allied Health Professional",
                "is_system_course_category": null
            },
            {
                "course_category_id": "E24BC24C-40B4-DF11-9F38-0015171C5BB1",
                "course_category_name": "CNE - Continuing Nurse Education",
                "is_system_course_category": null
            },
            {
                "course_category_id": "1D5C5A97-08DB-E511-AA9E-005056B17E48",
                "course_category_name": "Women's Health",
                "is_system_course_category": null
            },
            {
                "course_category_id": "BF92C7B7-00C9-E511-BC00-005056B1263C",
                "course_category_name": "Ambulatory Care",
                "is_system_course_category": null
            },
            {
                "course_category_id": "EE2F1978-C2F1-E311-941D-005056B1522B",
                "course_category_name": "AWHONN - Association of Women's Health, Obstetric, and Neonatal Nurses",
                "is_system_course_category": null
            },
            {
                "course_category_id": "1F4B1A8B-1EC9-E511-8771-005056B104B1",
                "course_category_name": "Nurse Midwife",
                "is_system_course_category": null
            },
            {
                "course_category_id": "33607431-5FF9-E611-B748-005056B122EA",
                "course_category_name": "Maternal Newborn",
                "is_system_course_category": null
            },
            {
                "course_category_id": "4F027BAC-08C9-E511-8771-005056B104B1",
                "course_category_name": "Clinical Nurse Specialist",
                "is_system_course_category": null
            }
        ],
        "ce_accreditation": {
            "accrediting_body_name": "ANCC",
            "accreditation_statement": "",
            "course_level_accreditation_statement": "The Association of Women&rsquo;s Health, Obstetric and Neonatal Nurses is accredited as a provider of nursing continuing professional development by the American Nurses Credentialing Center&rsquo;s Commission on Accreditation. Accredited status does not imply endorsement by AWHONN or ANCC of any commercial products discussed/displayed in conjunction with the educational activity. AWHONN is approved by the California Board of Registered Nursing, Provider #CEP580.<br />\r\n<br />",
            "credit_display_name": "ANCC CNE Credit",
            "credit_units": 3.25,
            "credit_unit_display_name": "ANCC Contact\r\nHour(s)"
        },
        "sub_courses": []
    },
    {
        "course_id": "E09FE56B-E8E2-ED11-80FD-005056B107A8",
        "course_version": 2,
        "name": "AWHONN NOEP - Module 03 - Physical Assessment",
        "course_type": 1,
        "author_information": "The Neonatal Orientation and Education Program (NOEP) was published through the coordinated efforts of a team of dedicated AWHONN members and staff. Disclosures:\u202fNo commercial support or sponsorship was received for this presentation. The AWHONN nurse planner, contributors, and reviewers report no relevant financial or commercial conflicts related to this educational activity. Disclosures:\u202fNo commercial support or sponsorship was received for this presentation. The AWHONN nurse planner, contributors, and reviewers report no relevant financial or commercial conflicts related to this educational activity.",
        "description": "The purpose of this module is to provide an overview of gestational age and physical maturity assessments and alterations in growth patterns by using a systematic approach when performing a physical assessment of the newborn.",
        "learning_objectives_html": "At the completion of Module 03 the learner will be able to:\r\n<ul>\r\n    <li>Organize the physical assessment of the newborn using a systematic approach.<span style=\"white-space: pre;\">\t\t</span></li>\r\n    <li>Distinguish between normal and abnormal physical assessment findings for the newborn.<span style=\"white-space: pre;\">\t\t</span></li>\r\n    <li>Anticipate nursing care for neonates born with congenital defects.<span style=\"white-space: pre;\">\t</span><br />\r\n    <div>&nbsp;</div>\r\n    </li>\r\n</ul>",
        "course_outline_html": "Please refer to your administrator for course outlines.",
        "credit_info": "-",
        "categories": [
            {
                "course_category_id": "F7C94142-A78D-EB11-80DF-005056B1202E",
                "course_category_name": "AWHONN - AWHONN NOEP Library (Resources in separate folder)",
                "is_system_course_category": null
            },
            {
                "course_category_id": "4F027BAC-08C9-E511-8771-005056B104B1",
                "course_category_name": "Clinical Nurse Specialist",
                "is_system_course_category": null
            },
            {
                "course_category_id": "43D048A0-1EC9-E511-8771-005056B104B1",
                "course_category_name": "Nurse",
                "is_system_course_category": null
            },
            {
                "course_category_id": "4D1B82BB-02C9-E511-8771-005056B104B1",
                "course_category_name": "Acute Care Facility",
                "is_system_course_category": null
            },
            {
                "course_category_id": "897AA72F-A78D-EB11-80DF-005056B1202E",
                "course_category_name": "AWHONN NOEP Library",
                "is_system_course_category": null
            },
            {
                "course_category_id": "0DFB1B0D-04C9-E511-8771-005056B104B1",
                "course_category_name": "Allied Health Professional",
                "is_system_course_category": null
            },
            {
                "course_category_id": "2FA45D8A-264F-DB11-9011-000423ACEF71",
                "course_category_name": "Obstetrics and Gynecology",
                "is_system_course_category": null
            },
            {
                "course_category_id": "33607431-5FF9-E611-B748-005056B122EA",
                "course_category_name": "Maternal Newborn",
                "is_system_course_category": null
            },
            {
                "course_category_id": "BF92C7B7-00C9-E511-BC00-005056B1263C",
                "course_category_name": "Ambulatory Care",
                "is_system_course_category": null
            },
            {
                "course_category_id": "EE2F1978-C2F1-E311-941D-005056B1522B",
                "course_category_name": "AWHONN - Association of Women's Health, Obstetric, and Neonatal Nurses",
                "is_system_course_category": null
            },
            {
                "course_category_id": "1F4B1A8B-1EC9-E511-8771-005056B104B1",
                "course_category_name": "Nurse Midwife",
                "is_system_course_category": null
            },
            {
                "course_category_id": "1D5C5A97-08DB-E511-AA9E-005056B17E48",
                "course_category_name": "Women's Health",
                "is_system_course_category": null
            },
            {
                "course_category_id": "E24BC24C-40B4-DF11-9F38-0015171C5BB1",
                "course_category_name": "CNE - Continuing Nurse Education",
                "is_system_course_category": null
            }
        ],
        "ce_accreditation": {
            "accrediting_body_name": "ANCC",
            "accreditation_statement": "",
            "course_level_accreditation_statement": "The Association of Women&rsquo;s Health, Obstetric and Neonatal Nurses is accredited as a provider of nursing continuing professional development by the American Nurses Credentialing Center&rsquo;s Commission on Accreditation. Accredited status does not imply endorsement by AWHONN or ANCC of any commercial products discussed/displayed in conjunction with the educational activity. AWHONN is approved by the California Board of Registered Nursing, Provider #CEP580",
            "credit_display_name": "ANCC CNE Credit",
            "credit_units": 3.5,
            "credit_unit_display_name": "ANCC Contact\r\nHour(s)"
        },
        "sub_courses": []
    },
    {
        "course_id": "9D8FDC9E-8898-EB11-80E0-005056B17014",
        "course_version": 4,
        "name": "AWHONN NOEP - Module 04 - The Respiratory System",
        "course_type": 1,
        "author_information": "The Neonatal Orientation and Education Program (NOEP) was published through the coordinated efforts of a team of dedicated AWHONN members and staff. Disclosures:\u202fNo commercial support or sponsorship was received for this presentation. The AWHONN nurse planner, contributors, and reviewers report no relevant financial or commercial conflicts related to this educational activity.",
        "description": "The purpose of this module is to provide an overview of the respiratory system. It begins with a review of lung development, focusing on physiology. The importance of oxygenation and ventilation, including the different modalities to provide respiratory support, are discussed, along with blood gas interpretation. Common disorders of respiratory distress are presented, including their etiology, presenting symptoms, and management. In addition, common respiratory disorders will be reviewed, including both pulmonary and non-pulmonary types of respiratory distress. The module describes concepts and mechanical principles of various modes of ventilation. Nursing interventions for ventilated neonates are identified, and complications associated with mechanical ventilation and medications used to enhance lung status in the ventilated neonate are also covered.",
        "learning_objectives_html": "At the completion of Module 04 the learner will be able to:\r\n<ul>\r\n    <li>Review the application of various types of respiratory support, including oxygen, continuous positive airway pressure (CPAP), and mechanical ventilation.<span style=\"white-space: pre;\">\t\t</span></li>\r\n    <li>Discuss the etiology, pathophysiology, clinical presentation, and diagnostic evaluation for neonates with respiratory disorders.<span style=\"white-space: pre;\">\t\t</span></li>\r\n    <li>Describe management of neonates with respiratory disorders.<span style=\"white-space: pre;\">\t</span><br />\r\n    <div>&nbsp;</div>\r\n    </li>\r\n</ul>",
        "course_outline_html": "Please refer to your administrator for course outlines.",
        "credit_info": "-",
        "categories": [
            {
                "course_category_id": "80F07F74-26FE-E611-A7FF-005056B16BE3",
                "course_category_name": "Neonatal Disorders",
                "is_system_course_category": null
            },
            {
                "course_category_id": "E24BC24C-40B4-DF11-9F38-0015171C5BB1",
                "course_category_name": "CNE - Continuing Nurse Education",
                "is_system_course_category": null
            },
            {
                "course_category_id": "0DFB1B0D-04C9-E511-8771-005056B104B1",
                "course_category_name": "Allied Health Professional",
                "is_system_course_category": null
            },
            {
                "course_category_id": "897AA72F-A78D-EB11-80DF-005056B1202E",
                "course_category_name": "AWHONN NOEP Library",
                "is_system_course_category": null
            },
            {
                "course_category_id": "2FA45D8A-264F-DB11-9011-000423ACEF71",
                "course_category_name": "Obstetrics and Gynecology",
                "is_system_course_category": null
            },
            {
                "course_category_id": "1F4B1A8B-1EC9-E511-8771-005056B104B1",
                "course_category_name": "Nurse Midwife",
                "is_system_course_category": null
            },
            {
                "course_category_id": "EE2F1978-C2F1-E311-941D-005056B1522B",
                "course_category_name": "AWHONN - Association of Women's Health, Obstetric, and Neonatal Nurses",
                "is_system_course_category": null
            },
            {
                "course_category_id": "33607431-5FF9-E611-B748-005056B122EA",
                "course_category_name": "Maternal Newborn",
                "is_system_course_category": null
            },
            {
                "course_category_id": "1D5C5A97-08DB-E511-AA9E-005056B17E48",
                "course_category_name": "Women's Health",
                "is_system_course_category": null
            },
            {
                "course_category_id": "4F027BAC-08C9-E511-8771-005056B104B1",
                "course_category_name": "Clinical Nurse Specialist",
                "is_system_course_category": null
            },
            {
                "course_category_id": "F7C94142-A78D-EB11-80DF-005056B1202E",
                "course_category_name": "AWHONN - AWHONN NOEP Library (Resources in separate folder)",
                "is_system_course_category": null
            },
            {
                "course_category_id": "4D1B82BB-02C9-E511-8771-005056B104B1",
                "course_category_name": "Acute Care Facility",
                "is_system_course_category": null
            },
            {
                "course_category_id": "BF92C7B7-00C9-E511-BC00-005056B1263C",
                "course_category_name": "Ambulatory Care",
                "is_system_course_category": null
            },
            {
                "course_category_id": "43D048A0-1EC9-E511-8771-005056B104B1",
                "course_category_name": "Nurse",
                "is_system_course_category": null
            },
            {
                "course_category_id": "58382785-93D1-E511-BF53-005056B122EA",
                "course_category_name": "Respiratory Care",
                "is_system_course_category": null
            }
        ],
        "ce_accreditation": {
            "accrediting_body_name": "ANCC",
            "accreditation_statement": "",
            "course_level_accreditation_statement": "The Association of Women&rsquo;s Health, Obstetric and Neonatal Nurses is accredited as a provider of nursing continuing professional development by the American Nurses Credentialing Center&rsquo;s Commission on Accreditation. Accredited status does not imply endorsement by AWHONN or ANCC of any commercial products discussed/displayed in conjunction with the educational activity. AWHONN is approved by the California Board of Registered Nursing, Provider #CEP580.",
            "credit_display_name": "ANCC CNE Credit",
            "credit_units": 4.75,
            "credit_unit_display_name": "ANCC Contact\r\nHour(s)"
        },
        "sub_courses": []
    },
    {
        "course_id": "F30824A2-AA98-EB11-80E0-005056B17014",
        "course_version": 4,
        "name": "AWHONN NOEP - Module 05 - The Cardiovascular System",
        "course_type": 1,
        "author_information": "The Neonatal Orientation and Education Program (NOEP) was published through the coordinated efforts of a team of dedicated AWHONN members and staff. Disclosures:\u202fNo commercial support or sponsorship was received for this presentation. The AWHONN nurse planner, contributors, and reviewers report no relevant financial or commercial conflicts related to this educational activity.",
        "description": "The purpose of this module is to provide an overview of the newborn\u2019s cardiovascular system. The module begins with a review of fetal cardiac development and newborn cardiac anatomy and physiology. An overview of the conduction system and common dysrythmias in the newborn period are discussed. An introduction to congenital heart defects (CHD), management of CHD, and a systematic approach to ruling out cardiac disease in the newborn is presented. Congestive heart failure and shock, which frequently occur in conditions unrelated to the cardiovascular system, are also discussed.",
        "learning_objectives_html": "At the completion of Module 05 the learner will be able to:\r\n<ul>\r\n    <li>Discuss common cardiac dysrhythmias in newborns and identify appropriate interventions.</li>\r\n    <li>Implement a systematic approach to identifying and diagnosing a newborn with suspected congenital heart defects (CHD).</li>\r\n    <li>Describe the anatomy, clinical manifestations, and diagnostic interventions for newborns with CHD, along with medical and nursing management.</li>\r\n    <li>Identify etiologies, manifestations, and management for the newborn in congestive heart failure (CHF).</li>\r\n    <li>Identify etiologies, manifestations, and management for the newborn experiencing shock.<span style=\"white-space: pre;\">\t</span><br />\r\n    <div>&nbsp;</div>\r\n    </li>\r\n</ul>",
        "course_outline_html": "Please refer to your administrator for course outlines.",
        "credit_info": "-",
        "categories": [
            {
                "course_category_id": "43D048A0-1EC9-E511-8771-005056B104B1",
                "course_category_name": "Nurse",
                "is_system_course_category": null
            },
            {
                "course_category_id": "2FA45D8A-264F-DB11-9011-000423ACEF71",
                "course_category_name": "Obstetrics and Gynecology",
                "is_system_course_category": null
            },
            {
                "course_category_id": "E24BC24C-40B4-DF11-9F38-0015171C5BB1",
                "course_category_name": "CNE - Continuing Nurse Education",
                "is_system_course_category": null
            },
            {
                "course_category_id": "4D1B82BB-02C9-E511-8771-005056B104B1",
                "course_category_name": "Acute Care Facility",
                "is_system_course_category": null
            },
            {
                "course_category_id": "80F07F74-26FE-E611-A7FF-005056B16BE3",
                "course_category_name": "Neonatal Disorders",
                "is_system_course_category": null
            },
            {
                "course_category_id": "33607431-5FF9-E611-B748-005056B122EA",
                "course_category_name": "Maternal Newborn",
                "is_system_course_category": null
            },
            {
                "course_category_id": "0DFB1B0D-04C9-E511-8771-005056B104B1",
                "course_category_name": "Allied Health Professional",
                "is_system_course_category": null
            },
            {
                "course_category_id": "1D5C5A97-08DB-E511-AA9E-005056B17E48",
                "course_category_name": "Women's Health",
                "is_system_course_category": null
            },
            {
                "course_category_id": "897AA72F-A78D-EB11-80DF-005056B1202E",
                "course_category_name": "AWHONN NOEP Library",
                "is_system_course_category": null
            },
            {
                "course_category_id": "F7C94142-A78D-EB11-80DF-005056B1202E",
                "course_category_name": "AWHONN - AWHONN NOEP Library (Resources in separate folder)",
                "is_system_course_category": null
            },
            {
                "course_category_id": "4F027BAC-08C9-E511-8771-005056B104B1",
                "course_category_name": "Clinical Nurse Specialist",
                "is_system_course_category": null
            },
            {
                "course_category_id": "EE2F1978-C2F1-E311-941D-005056B1522B",
                "course_category_name": "AWHONN - Association of Women's Health, Obstetric, and Neonatal Nurses",
                "is_system_course_category": null
            },
            {
                "course_category_id": "BF92C7B7-00C9-E511-BC00-005056B1263C",
                "course_category_name": "Ambulatory Care",
                "is_system_course_category": null
            },
            {
                "course_category_id": "1F4B1A8B-1EC9-E511-8771-005056B104B1",
                "course_category_name": "Nurse Midwife",
                "is_system_course_category": null
            },
            {
                "course_category_id": "6FCCD559-0EBF-E211-97A9-001517135213",
                "course_category_name": "Cardiac Care",
                "is_system_course_category": null
            }
        ],
        "ce_accreditation": {
            "accrediting_body_name": "ANCC",
            "accreditation_statement": "",
            "course_level_accreditation_statement": "The Association of Women&rsquo;s Health, Obstetric and Neonatal Nurses is accredited as a provider of nursing continuing professional development by the American Nurses Credentialing Center&rsquo;s Commission on Accreditation. Accredited status does not imply endorsement by AWHONN or ANCC of any commercial products discussed/displayed in conjunction with the educational activity. AWHONN is approved by the California Board of Registered Nursing, Provider #CEP580.",
            "credit_display_name": "ANCC CNE Credit",
            "credit_units": 3.0,
            "credit_unit_display_name": "ANCC Contact\r\nHour(s)"
        },
        "sub_courses": []
    },
    {
        "course_id": "D588CFC0-3799-EB11-80E0-005056B1202E",
        "course_version": 4,
        "name": "AWHONN NOEP - Module 06 - The Gastrointestinal System",
        "course_type": 1,
        "author_information": "The Neonatal Orientation and Education Program (NOEP) was published through the coordinated efforts of a team of dedicated AWHONN members and staff. Disclosures:\u202fNo commercial support or sponsorship was received for this presentation. The AWHONN nurse planner, contributors, and reviewers report no relevant financial or commercial conflicts related to this educational activity.",
        "description": "The purpose of this module is to review the functional development of the gastrointestinal (GI) tract, describe the systematic assessment of the GI system, and identify common causes of dysfunction. The most common gastrointestinal disorders, including clinical presentation, diagnostic testing, and patient management will be discussed.",
        "learning_objectives_html": "At the completion of Module 06 the learner will be able to:\r\n<ul>\r\n    <li>Identify the functions of the gastrointestinal (GI) tract.<span style=\"white-space: pre;\">\t\t</span></li>\r\n    <li>Discuss the key elements of a systematic physical assessment of the GI tract.<span style=\"white-space: pre;\">\t\t</span></li>\r\n    <li>Describe the etiology, pathophysiology, and clinical presentation of the most common GI disorders in the neonate.<span style=\"white-space: pre;\">\t\t</span></li>\r\n    <li>Discuss the diagnostic evaluation and management of the most common GI disorders in the neonate.<span style=\"white-space: pre;\">\t</span> </li>\r\n</ul>",
        "course_outline_html": "Please refer to your administrator for course outlines.",
        "credit_info": "-",
        "categories": [
            {
                "course_category_id": "43D048A0-1EC9-E511-8771-005056B104B1",
                "course_category_name": "Nurse",
                "is_system_course_category": null
            },
            {
                "course_category_id": "897AA72F-A78D-EB11-80DF-005056B1202E",
                "course_category_name": "AWHONN NOEP Library",
                "is_system_course_category": null
            },
            {
                "course_category_id": "33607431-5FF9-E611-B748-005056B122EA",
                "course_category_name": "Maternal Newborn",
                "is_system_course_category": null
            },
            {
                "course_category_id": "4D1B82BB-02C9-E511-8771-005056B104B1",
                "course_category_name": "Acute Care Facility",
                "is_system_course_category": null
            },
            {
                "course_category_id": "4F027BAC-08C9-E511-8771-005056B104B1",
                "course_category_name": "Clinical Nurse Specialist",
                "is_system_course_category": null
            },
            {
                "course_category_id": "0DFB1B0D-04C9-E511-8771-005056B104B1",
                "course_category_name": "Allied Health Professional",
                "is_system_course_category": null
            },
            {
                "course_category_id": "F7C94142-A78D-EB11-80DF-005056B1202E",
                "course_category_name": "AWHONN - AWHONN NOEP Library (Resources in separate folder)",
                "is_system_course_category": null
            },
            {
                "course_category_id": "2FA45D8A-264F-DB11-9011-000423ACEF71",
                "course_category_name": "Obstetrics and Gynecology",
                "is_system_course_category": null
            },
            {
                "course_category_id": "B1D5F710-EFD0-E511-AEA0-005056B11FFF",
                "course_category_name": "Gastrointestinal Care",
                "is_system_course_category": null
            },
            {
                "course_category_id": "80F07F74-26FE-E611-A7FF-005056B16BE3",
                "course_category_name": "Neonatal Disorders",
                "is_system_course_category": null
            },
            {
                "course_category_id": "1F4B1A8B-1EC9-E511-8771-005056B104B1",
                "course_category_name": "Nurse Midwife",
                "is_system_course_category": null
            },
            {
                "course_category_id": "EE2F1978-C2F1-E311-941D-005056B1522B",
                "course_category_name": "AWHONN - Association of Women's Health, Obstetric, and Neonatal Nurses",
                "is_system_course_category": null
            },
            {
                "course_category_id": "E24BC24C-40B4-DF11-9F38-0015171C5BB1",
                "course_category_name": "CNE - Continuing Nurse Education",
                "is_system_course_category": null
            },
            {
                "course_category_id": "BF92C7B7-00C9-E511-BC00-005056B1263C",
                "course_category_name": "Ambulatory Care",
                "is_system_course_category": null
            },
            {
                "course_category_id": "1D5C5A97-08DB-E511-AA9E-005056B17E48",
                "course_category_name": "Women's Health",
                "is_system_course_category": null
            }
        ],
        "ce_accreditation": {
            "accrediting_body_name": "ANCC",
            "accreditation_statement": "",
            "course_level_accreditation_statement": "The Association of Women&rsquo;s Health, Obstetric and Neonatal Nurses is accredited as a provider of nursing continuing professional development by the American Nurses Credentialing Center&rsquo;s Commission on Accreditation. Accredited status does not imply endorsement by AWHONN or ANCC of any commercial products discussed/displayed in conjunction with the educational activity. AWHONN is approved by the California Board of Registered Nursing, Provider #CEP580.",
            "credit_display_name": "ANCC CNE Credit",
            "credit_units": 2.0,
            "credit_unit_display_name": "ANCC Contact\r\nHour(s)"
        },
        "sub_courses": []
    },
    {
        "course_id": "2453E110-AD98-EB11-80E0-005056B17014",
        "course_version": 4,
        "name": "AWHONN NOEP - Module 07 - Metabolic and Nutritional Support",
        "course_type": 1,
        "author_information": "The Neonatal Orientation and Education Program (NOEP) was published through the coordinated efforts of a team of dedicated AWHONN members and staff. Disclosures:\u202fNo commercial support or sponsorship was received for this presentation. The AWHONN nurse planner, contributors, and reviewers report no relevant financial or commercial conflicts related to this educational activity.",
        "description": "An essential part of successful transition to extrauterine life is the achievement of fluid, electrolyte, and glucose homeostasis. The purpose of this module is to identify the metabolic and nutritional needs of the neonate who requires tertiary care. The principles of fluid and electrolyte homeostasis and fluid and electrolyte management will be reviewed, as well as the mechanisms of glucose homeostasis and the pathophysiology of hypoglycemia and hyperglycemia. The content will also review trophic feedings, advancement of feedings, and a brief overview of developmentally supportive strategies that promote feeding success.",
        "learning_objectives_html": "At the completion of Module 07 the learner will be able to:\r\n<ul>\r\n    <li>Define the principles of fluid and electrolyte management in the preterm and full term neonate.</li>\r\n    <li>Discuss the management of electrolyte abnormalities in the neonatal period.</li>\r\n    <li>Identify the mechanisms of glucose homeostasis in the fetus and newborn.</li>\r\n    <li>Describe various interventions to promote nutrition in the compromised neonate, including IV therapy, trophic feedings, enteral feedings, and oral feedings.</li>\r\n    <li>Describe developmentally supportive strategies that promote feeding success in the NICU.<br />\r\n    <div>&nbsp;</div>\r\n    </li>\r\n</ul>",
        "course_outline_html": "Please refer to your administrator for course outlines.",
        "credit_info": "-",
        "categories": [
            {
                "course_category_id": "4F027BAC-08C9-E511-8771-005056B104B1",
                "course_category_name": "Clinical Nurse Specialist",
                "is_system_course_category": null
            },
            {
                "course_category_id": "EE2F1978-C2F1-E311-941D-005056B1522B",
                "course_category_name": "AWHONN - Association of Women's Health, Obstetric, and Neonatal Nurses",
                "is_system_course_category": null
            },
            {
                "course_category_id": "BF92C7B7-00C9-E511-BC00-005056B1263C",
                "course_category_name": "Ambulatory Care",
                "is_system_course_category": null
            },
            {
                "course_category_id": "33607431-5FF9-E611-B748-005056B122EA",
                "course_category_name": "Maternal Newborn",
                "is_system_course_category": null
            },
            {
                "course_category_id": "897AA72F-A78D-EB11-80DF-005056B1202E",
                "course_category_name": "AWHONN NOEP Library",
                "is_system_course_category": null
            },
            {
                "course_category_id": "2FA45D8A-264F-DB11-9011-000423ACEF71",
                "course_category_name": "Obstetrics and Gynecology",
                "is_system_course_category": null
            },
            {
                "course_category_id": "F7C94142-A78D-EB11-80DF-005056B1202E",
                "course_category_name": "AWHONN - AWHONN NOEP Library (Resources in separate folder)",
                "is_system_course_category": null
            },
            {
                "course_category_id": "0DFB1B0D-04C9-E511-8771-005056B104B1",
                "course_category_name": "Allied Health Professional",
                "is_system_course_category": null
            },
            {
                "course_category_id": "E24BC24C-40B4-DF11-9F38-0015171C5BB1",
                "course_category_name": "CNE - Continuing Nurse Education",
                "is_system_course_category": null
            },
            {
                "course_category_id": "43D048A0-1EC9-E511-8771-005056B104B1",
                "course_category_name": "Nurse",
                "is_system_course_category": null
            },
            {
                "course_category_id": "4D1B82BB-02C9-E511-8771-005056B104B1",
                "course_category_name": "Acute Care Facility",
                "is_system_course_category": null
            },
            {
                "course_category_id": "1D5C5A97-08DB-E511-AA9E-005056B17E48",
                "course_category_name": "Women's Health",
                "is_system_course_category": null
            },
            {
                "course_category_id": "1F4B1A8B-1EC9-E511-8771-005056B104B1",
                "course_category_name": "Nurse Midwife",
                "is_system_course_category": null
            }
        ],
        "ce_accreditation": {
            "accrediting_body_name": "ANCC",
            "accreditation_statement": "",
            "course_level_accreditation_statement": "The Association of Women&rsquo;s Health, Obstetric and Neonatal Nurses is accredited as a provider of nursing continuing professional development by the American Nurses Credentialing Center&rsquo;s Commission on Accreditation. Accredited status does not imply endorsement by AWHONN or ANCC of any commercial products discussed/displayed in conjunction with the educational activity. AWHONN is approved by the California Board of Registered Nursing, Provider #CEP580.",
            "credit_display_name": "ANCC CNE Credit",
            "credit_units": 2.0,
            "credit_unit_display_name": "ANCC Contact\r\nHour(s)"
        },
        "sub_courses": []
    },
    {
        "course_id": "8780256C-AF98-EB11-80E0-005056B17014",
        "course_version": 4,
        "name": "AWHONN NOEP - Module 08 - Renal and Endocrine Systems",
        "course_type": 1,
        "author_information": "The Neonatal Orientation and Education Program (NOEP) was published through the coordinated efforts of a team of dedicated AWHONN members and staff. Disclosures:\u202fNo commercial support or sponsorship was received for this presentation. The AWHONN nurse planner, contributors, and reviewers report no relevant financial or commercial conflicts related to this educational activity.",
        "description": "The purpose of this module is to identify disorders of the renal and endocrine systems. The discussion includes renal anatomy, physiology and pathophysiology, clinical presentation, diagnostic testing, and patient management of renal and genitourinary disorders. The module also reviews dysfunction of the thyroid and adrenal glands, as well as disorders of sexual development.",
        "learning_objectives_html": "At the completion of Module 08 the learner will be able to:\r\n<ul>\r\n    <li>Recognize the effects of fetal renal system development on renal and genitourinary disorders.&nbsp;</li>\r\n    <li>Discuss the clinical presentation and management of neonates with renal or genitourinary disorders.</li>\r\n    <li>Explain the function of the thyroid and adrenal glands.</li>\r\n    <li>Discuss the clinical presentation and management of neonates with congenital endocrine disorders. <span style=\"white-space: pre;\">\t</span> </li>\r\n</ul>",
        "course_outline_html": "Please refer to your administrator for course outlines.",
        "credit_info": "-",
        "categories": [
            {
                "course_category_id": "80F07F74-26FE-E611-A7FF-005056B16BE3",
                "course_category_name": "Neonatal Disorders",
                "is_system_course_category": null
            },
            {
                "course_category_id": "1F4B1A8B-1EC9-E511-8771-005056B104B1",
                "course_category_name": "Nurse Midwife",
                "is_system_course_category": null
            },
            {
                "course_category_id": "EE2F1978-C2F1-E311-941D-005056B1522B",
                "course_category_name": "AWHONN - Association of Women's Health, Obstetric, and Neonatal Nurses",
                "is_system_course_category": null
            },
            {
                "course_category_id": "BF92C7B7-00C9-E511-BC00-005056B1263C",
                "course_category_name": "Ambulatory Care",
                "is_system_course_category": null
            },
            {
                "course_category_id": "E24BC24C-40B4-DF11-9F38-0015171C5BB1",
                "course_category_name": "CNE - Continuing Nurse Education",
                "is_system_course_category": null
            },
            {
                "course_category_id": "3F5D55B4-EDF9-E611-AF66-005056B104B1",
                "course_category_name": "Renal Care",
                "is_system_course_category": null
            },
            {
                "course_category_id": "4F027BAC-08C9-E511-8771-005056B104B1",
                "course_category_name": "Clinical Nurse Specialist",
                "is_system_course_category": null
            },
            {
                "course_category_id": "1D5C5A97-08DB-E511-AA9E-005056B17E48",
                "course_category_name": "Women's Health",
                "is_system_course_category": null
            },
            {
                "course_category_id": "33607431-5FF9-E611-B748-005056B122EA",
                "course_category_name": "Maternal Newborn",
                "is_system_course_category": null
            },
            {
                "course_category_id": "2FA45D8A-264F-DB11-9011-000423ACEF71",
                "course_category_name": "Obstetrics and Gynecology",
                "is_system_course_category": null
            },
            {
                "course_category_id": "43D048A0-1EC9-E511-8771-005056B104B1",
                "course_category_name": "Nurse",
                "is_system_course_category": null
            },
            {
                "course_category_id": "897AA72F-A78D-EB11-80DF-005056B1202E",
                "course_category_name": "AWHONN NOEP Library",
                "is_system_course_category": null
            },
            {
                "course_category_id": "4D1B82BB-02C9-E511-8771-005056B104B1",
                "course_category_name": "Acute Care Facility",
                "is_system_course_category": null
            },
            {
                "course_category_id": "0DFB1B0D-04C9-E511-8771-005056B104B1",
                "course_category_name": "Allied Health Professional",
                "is_system_course_category": null
            },
            {
                "course_category_id": "F7C94142-A78D-EB11-80DF-005056B1202E",
                "course_category_name": "AWHONN - AWHONN NOEP Library (Resources in separate folder)",
                "is_system_course_category": null
            },
            {
                "course_category_id": "072BCB26-CFC9-E511-82AF-005056B150D3",
                "course_category_name": "Endocrine Care",
                "is_system_course_category": null
            }
        ],
        "ce_accreditation": {
            "accrediting_body_name": "ANCC",
            "accreditation_statement": "",
            "course_level_accreditation_statement": "The Association of Women&rsquo;s Health, Obstetric and Neonatal Nurses is accredited as a provider of nursing continuing professional development by the American Nurses Credentialing Center&rsquo;s Commission on Accreditation. Accredited status does not imply endorsement by AWHONN or ANCC of any commercial products discussed/displayed in conjunction with the educational activity. AWHONN is approved by the California Board of Registered Nursing, Provider #CEP580.",
            "credit_display_name": "ANCC CNE Credit",
            "credit_units": 2.25,
            "credit_unit_display_name": "ANCC Contact\r\nHour(s)"
        },
        "sub_courses": []
    },
    {
        "course_id": "EA758BF1-3599-EB11-80E0-005056B1202E",
        "course_version": 4,
        "name": "AWHONN NOEP - Module 09 - Hematology and Immunology",
        "course_type": 1,
        "author_information": "The Neonatal Orientation and Education Program (NOEP) was published through the coordinated efforts of a team of dedicated AWHONN members and staff. Disclosures:\u202fNo commercial support or sponsorship was received for this presentation. The AWHONN nurse planner, contributors, and reviewers report no relevant financial or commercial conflicts related to this educational activity.",
        "description": "This module provides an overview of the neonatal hematologic system as well as the clinical presentation and management of neonatal hematologic disorders. The discussion begins with blood cell formation and focuses on disorders of coagulation that lead to bleeding. The newborn immunologic system will be reviewed with an emphasis on neonatal infection and treatment modalities. The pathophysiology and treatment guidelines for hyperbilirubinemia will also be explored.",
        "learning_objectives_html": "At the completion of Module 09 the learner will be able to:\r\n<ul>\r\n    <li>Examine the pathology of hematopoiesis and hemostasis.</li>\r\n    <li>Describe the pathology related to hemorrhagic disease in the newborn.</li>\r\n    <li>Differentiate between the clinical presentations of bacterial, viral, and fungal sepsis in the neonate.</li>\r\n    <li>Identify an individualized plan of care for the newborn at risk for hyperbilirubinemia.<br />\r\n    <div>&nbsp;</div>\r\n    </li>\r\n</ul>",
        "course_outline_html": "Please refer to your administrator for course outlines.",
        "credit_info": "-",
        "categories": [
            {
                "course_category_id": "80F07F74-26FE-E611-A7FF-005056B16BE3",
                "course_category_name": "Neonatal Disorders",
                "is_system_course_category": null
            },
            {
                "course_category_id": "1D5C5A97-08DB-E511-AA9E-005056B17E48",
                "course_category_name": "Women's Health",
                "is_system_course_category": null
            },
            {
                "course_category_id": "EE2F1978-C2F1-E311-941D-005056B1522B",
                "course_category_name": "AWHONN - Association of Women's Health, Obstetric, and Neonatal Nurses",
                "is_system_course_category": null
            },
            {
                "course_category_id": "0DFB1B0D-04C9-E511-8771-005056B104B1",
                "course_category_name": "Allied Health Professional",
                "is_system_course_category": null
            },
            {
                "course_category_id": "E24BC24C-40B4-DF11-9F38-0015171C5BB1",
                "course_category_name": "CNE - Continuing Nurse Education",
                "is_system_course_category": null
            },
            {
                "course_category_id": "D12F13F5-CF7A-11DC-8864-0015171353BD",
                "course_category_name": "Immunologic Disorders",
                "is_system_course_category": null
            },
            {
                "course_category_id": "1F4B1A8B-1EC9-E511-8771-005056B104B1",
                "course_category_name": "Nurse Midwife",
                "is_system_course_category": null
            },
            {
                "course_category_id": "33607431-5FF9-E611-B748-005056B122EA",
                "course_category_name": "Maternal Newborn",
                "is_system_course_category": null
            },
            {
                "course_category_id": "BC33B687-264F-DB11-9011-000423ACEF71",
                "course_category_name": "Hematologic & Lymphatic Disorders",
                "is_system_course_category": null
            },
            {
                "course_category_id": "2FA45D8A-264F-DB11-9011-000423ACEF71",
                "course_category_name": "Obstetrics and Gynecology",
                "is_system_course_category": null
            },
            {
                "course_category_id": "BF92C7B7-00C9-E511-BC00-005056B1263C",
                "course_category_name": "Ambulatory Care",
                "is_system_course_category": null
            },
            {
                "course_category_id": "F7C94142-A78D-EB11-80DF-005056B1202E",
                "course_category_name": "AWHONN - AWHONN NOEP Library (Resources in separate folder)",
                "is_system_course_category": null
            },
            {
                "course_category_id": "897AA72F-A78D-EB11-80DF-005056B1202E",
                "course_category_name": "AWHONN NOEP Library",
                "is_system_course_category": null
            },
            {
                "course_category_id": "4F027BAC-08C9-E511-8771-005056B104B1",
                "course_category_name": "Clinical Nurse Specialist",
                "is_system_course_category": null
            },
            {
                "course_category_id": "43D048A0-1EC9-E511-8771-005056B104B1",
                "course_category_name": "Nurse",
                "is_system_course_category": null
            },
            {
                "course_category_id": "4D1B82BB-02C9-E511-8771-005056B104B1",
                "course_category_name": "Acute Care Facility",
                "is_system_course_category": null
            }
        ],
        "ce_accreditation": {
            "accrediting_body_name": "ANCC",
            "accreditation_statement": "",
            "course_level_accreditation_statement": "The Association of Women&rsquo;s Health, Obstetric and Neonatal Nurses is accredited as a provider of nursing continuing professional development by the American Nurses Credentialing Center&rsquo;s Commission on Accreditation. Accredited status does not imply endorsement by AWHONN or ANCC of any commercial products discussed/displayed in conjunction with the educational activity. AWHONN is approved by the California Board of Registered Nursing, Provider #CEP580.",
            "credit_display_name": "ANCC CNE Credit",
            "credit_units": 3.25,
            "credit_unit_display_name": "ANCC Contact\r\nHour(s)"
        },
        "sub_courses": []
    },
    {
        "course_id": "EAE763A0-3899-EB11-80E0-005056B1202E",
        "course_version": 4,
        "name": "AWHONN NOEP - Module 10 - The Neurologic System",
        "course_type": 1,
        "author_information": "The Neonatal Orientation and Education Program (NOEP) was published through the coordinated efforts of a team of dedicated AWHONN members and staff. Disclosures:\u202fNo commercial support or sponsorship was received for this presentation. The AWHONN nurse planner, contributors, and reviewers report no relevant financial or commercial conflicts related to this educational activity.",
        "description": "Neonates in the neonatal intensive care unit (NICU) and the special care nursery are often born before the brain and central nervous system (CNS) have matured. This immaturity, especially in the context of underlying pathophysiology of other major organ systems, predisposes these neonates to neurologic injury. The purpose of this module is to review the anatomy of the brain and cerebral blood flow and to review assessment of the neurologic system. The module will also describe common neonatal neurologic disorders and review patient care interventions. Knowledge of the etiology, clinical presentation, and complications of neonatal neurologic conditions is essential in mitigating negative developmental outcomes.",
        "learning_objectives_html": "At the completion of Module 10 the learner will be able to:\r\n<ul>\r\n    <li>Describe the anatomy of the brain and intrauterine conditions that may impact brain development.</li>\r\n    <li>Define the key features of a comprehensive neurologic assessment.</li>\r\n    <li>Discuss the clinical presentation and management of common congenital neurologic anomalies.</li>\r\n    <li>Discuss the clinical presentation and management of common birth injuries.</li>\r\n    <li>Recognize the clinical implications of intraventricular hemorrhage (IVH) and periventricular leukomalacia (PVL).</li>\r\n    <li>Review diagnosis of hypoxic-ischemic encephalopathy (HIE) and treatment with neuroprotective cooling.<span style=\"white-space: pre;\">\t</span><br />\r\n    <div>&nbsp;</div>\r\n    </li>\r\n</ul>",
        "course_outline_html": "Please refer to your administrator for course outlines.",
        "credit_info": "-",
        "categories": [
            {
                "course_category_id": "F7C94142-A78D-EB11-80DF-005056B1202E",
                "course_category_name": "AWHONN - AWHONN NOEP Library (Resources in separate folder)",
                "is_system_course_category": null
            },
            {
                "course_category_id": "5D6D72E5-07DB-E511-AA9E-005056B17E48",
                "course_category_name": "Neurological Care",
                "is_system_course_category": null
            },
            {
                "course_category_id": "33607431-5FF9-E611-B748-005056B122EA",
                "course_category_name": "Maternal Newborn",
                "is_system_course_category": null
            },
            {
                "course_category_id": "0DFB1B0D-04C9-E511-8771-005056B104B1",
                "course_category_name": "Allied Health Professional",
                "is_system_course_category": null
            },
            {
                "course_category_id": "1F4B1A8B-1EC9-E511-8771-005056B104B1",
                "course_category_name": "Nurse Midwife",
                "is_system_course_category": null
            },
            {
                "course_category_id": "1D5C5A97-08DB-E511-AA9E-005056B17E48",
                "course_category_name": "Women's Health",
                "is_system_course_category": null
            },
            {
                "course_category_id": "4F027BAC-08C9-E511-8771-005056B104B1",
                "course_category_name": "Clinical Nurse Specialist",
                "is_system_course_category": null
            },
            {
                "course_category_id": "2FA45D8A-264F-DB11-9011-000423ACEF71",
                "course_category_name": "Obstetrics and Gynecology",
                "is_system_course_category": null
            },
            {
                "course_category_id": "80F07F74-26FE-E611-A7FF-005056B16BE3",
                "course_category_name": "Neonatal Disorders",
                "is_system_course_category": null
            },
            {
                "course_category_id": "E24BC24C-40B4-DF11-9F38-0015171C5BB1",
                "course_category_name": "CNE - Continuing Nurse Education",
                "is_system_course_category": null
            },
            {
                "course_category_id": "4D1B82BB-02C9-E511-8771-005056B104B1",
                "course_category_name": "Acute Care Facility",
                "is_system_course_category": null
            },
            {
                "course_category_id": "9E32CF83-389F-11DD-AD08-0015171C1B93",
                "course_category_name": "Neurological & Neurocognitive Disorders",
                "is_system_course_category": null
            },
            {
                "course_category_id": "43D048A0-1EC9-E511-8771-005056B104B1",
                "course_category_name": "Nurse",
                "is_system_course_category": null
            },
            {
                "course_category_id": "EE2F1978-C2F1-E311-941D-005056B1522B",
                "course_category_name": "AWHONN - Association of Women's Health, Obstetric, and Neonatal Nurses",
                "is_system_course_category": null
            },
            {
                "course_category_id": "897AA72F-A78D-EB11-80DF-005056B1202E",
                "course_category_name": "AWHONN NOEP Library",
                "is_system_course_category": null
            },
            {
                "course_category_id": "BF92C7B7-00C9-E511-BC00-005056B1263C",
                "course_category_name": "Ambulatory Care",
                "is_system_course_category": null
            }
        ],
        "ce_accreditation": {
            "accrediting_body_name": "ANCC",
            "accreditation_statement": "",
            "course_level_accreditation_statement": "The Association of Women&rsquo;s Health, Obstetric and Neonatal Nurses is accredited as a provider of nursing continuing professional development by the American Nurses Credentialing Center&rsquo;s Commission on Accreditation. Accredited status does not imply endorsement by AWHONN or ANCC of any commercial products discussed/displayed in conjunction with the educational activity. AWHONN is approved by the California Board of Registered Nursing, Provider #CEP580.",
            "credit_display_name": "ANCC CNE Credit",
            "credit_units": 1.75,
            "credit_unit_display_name": "ANCC Contact\r\nHour(s)"
        },
        "sub_courses": []
    },
    {
        "course_id": "432ECF5E-4599-EB11-80E0-005056B1202E",
        "course_version": 4,
        "name": "AWHONN NOEP - Module 11 - Issues Affecting the Late Preterm Infant",
        "course_type": 1,
        "author_information": "The Neonatal Orientation and Education Program (NOEP) was published through the coordinated efforts of a team of dedicated AWHONN members and staff. Disclosures:\u202fNo commercial support or sponsorship was received for this presentation. The AWHONN nurse planner, contributors, and reviewers report no relevant financial or commercial conflicts related to this educational activity.",
        "description": "The purpose of this module is to describe the epidemiology of the late preterm infant and discuss why this group is at high risk for complications, such as thermoregulation problems, hypoglycemia, respiratory distress, hyperbilirubinemia, sepsis, and feeding difficulties. Education for parents in preparation for hospital discharge will also be presented.",
        "learning_objectives_html": "At the completion of Module 11 the learner will be able to:\r\n<ul>\r\n    <li>Analyze the unique needs of the late preterm infant (LPI).</li>\r\n    <li>Identify the physiologic challenges and potential risks for the LPI.</li>\r\n    <li>Describe the management strategies to optimize a successful transition from birth to home for the LPI.<br />\r\n    <div>&nbsp;</div>\r\n    </li>\r\n</ul>",
        "course_outline_html": "Please refer to your administrator for course outlines.",
        "credit_info": "-",
        "categories": [
            {
                "course_category_id": "33607431-5FF9-E611-B748-005056B122EA",
                "course_category_name": "Maternal Newborn",
                "is_system_course_category": null
            },
            {
                "course_category_id": "0DFB1B0D-04C9-E511-8771-005056B104B1",
                "course_category_name": "Allied Health Professional",
                "is_system_course_category": null
            },
            {
                "course_category_id": "1F4B1A8B-1EC9-E511-8771-005056B104B1",
                "course_category_name": "Nurse Midwife",
                "is_system_course_category": null
            },
            {
                "course_category_id": "897AA72F-A78D-EB11-80DF-005056B1202E",
                "course_category_name": "AWHONN NOEP Library",
                "is_system_course_category": null
            },
            {
                "course_category_id": "2FA45D8A-264F-DB11-9011-000423ACEF71",
                "course_category_name": "Obstetrics and Gynecology",
                "is_system_course_category": null
            },
            {
                "course_category_id": "43D048A0-1EC9-E511-8771-005056B104B1",
                "course_category_name": "Nurse",
                "is_system_course_category": null
            },
            {
                "course_category_id": "4D1B82BB-02C9-E511-8771-005056B104B1",
                "course_category_name": "Acute Care Facility",
                "is_system_course_category": null
            },
            {
                "course_category_id": "BF92C7B7-00C9-E511-BC00-005056B1263C",
                "course_category_name": "Ambulatory Care",
                "is_system_course_category": null
            },
            {
                "course_category_id": "4F027BAC-08C9-E511-8771-005056B104B1",
                "course_category_name": "Clinical Nurse Specialist",
                "is_system_course_category": null
            },
            {
                "course_category_id": "EE2F1978-C2F1-E311-941D-005056B1522B",
                "course_category_name": "AWHONN - Association of Women's Health, Obstetric, and Neonatal Nurses",
                "is_system_course_category": null
            },
            {
                "course_category_id": "F7C94142-A78D-EB11-80DF-005056B1202E",
                "course_category_name": "AWHONN - AWHONN NOEP Library (Resources in separate folder)",
                "is_system_course_category": null
            },
            {
                "course_category_id": "E24BC24C-40B4-DF11-9F38-0015171C5BB1",
                "course_category_name": "CNE - Continuing Nurse Education",
                "is_system_course_category": null
            },
            {
                "course_category_id": "1D5C5A97-08DB-E511-AA9E-005056B17E48",
                "course_category_name": "Women's Health",
                "is_system_course_category": null
            }
        ],
        "ce_accreditation": {
            "accrediting_body_name": "ANCC",
            "accreditation_statement": "",
            "course_level_accreditation_statement": "The Association of Women&rsquo;s Health, Obstetric and Neonatal Nurses is accredited as a provider of nursing continuing professional development by the American Nurses Credentialing Center&rsquo;s Commission on Accreditation. Accredited status does not imply endorsement by AWHONN or ANCC of any commercial products discussed/displayed in conjunction with the educational activity. AWHONN is approved by the California Board of Registered Nursing, Provider #CEP580.",
            "credit_display_name": "ANCC CNE Credit",
            "credit_units": 1.75,
            "credit_unit_display_name": "ANCC Contact\r\nHour(s)"
        },
        "sub_courses": []
    },
    {
        "course_id": "71E2CADF-4099-EB11-80E0-005056B1202E",
        "course_version": 4,
        "name": "AWHONN NOEP - Module 12 - Newborn Skin and Skin Care",
        "course_type": 1,
        "author_information": "The Neonatal Orientation and Education Program (NOEP) was published through the coordinated efforts of a team of dedicated AWHONN members and staff. Disclosures:\u202fNo commercial support or sponsorship was received for this presentation. The AWHONN nurse planner, contributors, and reviewers report no relevant financial or commercial conflicts related to this educational activity.",
        "description": "The skin of the newborn is structurally and functionally immature compared with an adult. Understanding differences in skin composition and maturity between full term and preterm newborns is important when providing care to this population. The purpose of this module is to review the functions of the skin, identify common terms used to describe skin irregularities, and discuss ways to prevent iatrogenic damage, thus protecting the integrity of the skin and maintaining the newborn\u2019s first line of defense.",
        "learning_objectives_html": "At the completion of Module 12 the learner will be able to:\r\n<ul>\r\n    <li>Compare skin development and physiology in term and preterm newborns.</li>\r\n    <li>Identify different types of skin lesions.</li>\r\n    <li>Examine factors that can lead to increased risk for skin injury.</li>\r\n    <li>Describe interventions to promote skin integrity and healing.<br />\r\n    <div>&nbsp;</div>\r\n    </li>\r\n</ul>",
        "course_outline_html": "Please refer to your administrator for course outlines.",
        "credit_info": "-",
        "categories": [
            {
                "course_category_id": "F7C94142-A78D-EB11-80DF-005056B1202E",
                "course_category_name": "AWHONN - AWHONN NOEP Library (Resources in separate folder)",
                "is_system_course_category": null
            },
            {
                "course_category_id": "0DFB1B0D-04C9-E511-8771-005056B104B1",
                "course_category_name": "Allied Health Professional",
                "is_system_course_category": null
            },
            {
                "course_category_id": "897AA72F-A78D-EB11-80DF-005056B1202E",
                "course_category_name": "AWHONN NOEP Library",
                "is_system_course_category": null
            },
            {
                "course_category_id": "F06F18BC-1DFE-E611-A7FF-005056B16BE3",
                "course_category_name": "Dermatological Disorders",
                "is_system_course_category": null
            },
            {
                "course_category_id": "2FA45D8A-264F-DB11-9011-000423ACEF71",
                "course_category_name": "Obstetrics and Gynecology",
                "is_system_course_category": null
            },
            {
                "course_category_id": "4F027BAC-08C9-E511-8771-005056B104B1",
                "course_category_name": "Clinical Nurse Specialist",
                "is_system_course_category": null
            },
            {
                "course_category_id": "4D1B82BB-02C9-E511-8771-005056B104B1",
                "course_category_name": "Acute Care Facility",
                "is_system_course_category": null
            },
            {
                "course_category_id": "43D048A0-1EC9-E511-8771-005056B104B1",
                "course_category_name": "Nurse",
                "is_system_course_category": null
            },
            {
                "course_category_id": "1F4B1A8B-1EC9-E511-8771-005056B104B1",
                "course_category_name": "Nurse Midwife",
                "is_system_course_category": null
            },
            {
                "course_category_id": "8802F477-1E26-E711-9EDE-005056B14F90",
                "course_category_name": "Dermatologic Care",
                "is_system_course_category": null
            },
            {
                "course_category_id": "33607431-5FF9-E611-B748-005056B122EA",
                "course_category_name": "Maternal Newborn",
                "is_system_course_category": null
            },
            {
                "course_category_id": "BF92C7B7-00C9-E511-BC00-005056B1263C",
                "course_category_name": "Ambulatory Care",
                "is_system_course_category": null
            },
            {
                "course_category_id": "80F07F74-26FE-E611-A7FF-005056B16BE3",
                "course_category_name": "Neonatal Disorders",
                "is_system_course_category": null
            },
            {
                "course_category_id": "E24BC24C-40B4-DF11-9F38-0015171C5BB1",
                "course_category_name": "CNE - Continuing Nurse Education",
                "is_system_course_category": null
            },
            {
                "course_category_id": "EE2F1978-C2F1-E311-941D-005056B1522B",
                "course_category_name": "AWHONN - Association of Women's Health, Obstetric, and Neonatal Nurses",
                "is_system_course_category": null
            },
            {
                "course_category_id": "1D5C5A97-08DB-E511-AA9E-005056B17E48",
                "course_category_name": "Women's Health",
                "is_system_course_category": null
            }
        ],
        "ce_accreditation": {
            "accrediting_body_name": "ANCC",
            "accreditation_statement": "",
            "course_level_accreditation_statement": "The Association of Women&rsquo;s Health, Obstetric and Neonatal Nurses is accredited as a provider of nursing continuing professional development by the American Nurses Credentialing Center&rsquo;s Commission on Accreditation. Accredited status does not imply endorsement by AWHONN or ANCC of any commercial products discussed/displayed in conjunction with the educational activity. AWHONN is approved by the California Board of Registered Nursing, Provider #CEP580<br />\r\n<div>&nbsp;</div>",
            "credit_display_name": "ANCC CNE Credit",
            "credit_units": 1.75,
            "credit_unit_display_name": "ANCC Contact\r\nHour(s)"
        },
        "sub_courses": []
    },
    {
        "course_id": "746118E6-5499-EB11-80E0-005056B1202E",
        "course_version": 4,
        "name": "AWHONN NOEP - Module 13 - Lactation Support in the NICU",
        "course_type": 1,
        "author_information": "The Neonatal Orientation and Education Program (NOEP) was published through the coordinated efforts of a team of dedicated AWHONN members and staff. Disclosures:\u202fNo commercial support or sponsorship was received for this presentation. The AWHONN nurse planner, contributors, and reviewers report no relevant financial or commercial conflicts related to this educational activity.",
        "description": "The purpose of this module is to provide an overview of evidence-based lactation support in the neonatal intensive care unit (NICU), with a focus on helping mothers and infants achieve their personal breastfeeding goals. This module will provide the background and information needed by nurses to support NICU mother-infant dyads.",
        "learning_objectives_html": "At the completion of Module 13 the learner will be able to:\r\n<ul>\r\n    <li>Recognize the benefits of breastfeeding for the newborn, parents, and society.</li>\r\n    <li>Explain the differences between the birth parent&rsquo;s own milk, pasteurized donor human milk (PDHM), and formula.&nbsp;</li>\r\n    <li>Describe the physiology of lactation and measures necessary for the initiation and maintenance of milk supply.</li>\r\n    <li>Examine the ten steps for promoting and protecting breastfeeding for vulnerable infants and apply strategies to support the transition to breastfeeding.</li>\r\n    <li>Discuss common breastfeeding challenges and identify interventions.<br />\r\n    <div>&nbsp;</div>\r\n    </li>\r\n</ul>",
        "course_outline_html": "Please refer to your administrator for course outlines.",
        "credit_info": "-",
        "categories": [
            {
                "course_category_id": "E24BC24C-40B4-DF11-9F38-0015171C5BB1",
                "course_category_name": "CNE - Continuing Nurse Education",
                "is_system_course_category": null
            },
            {
                "course_category_id": "0DFB1B0D-04C9-E511-8771-005056B104B1",
                "course_category_name": "Allied Health Professional",
                "is_system_course_category": null
            },
            {
                "course_category_id": "1D5C5A97-08DB-E511-AA9E-005056B17E48",
                "course_category_name": "Women's Health",
                "is_system_course_category": null
            },
            {
                "course_category_id": "EE2F1978-C2F1-E311-941D-005056B1522B",
                "course_category_name": "AWHONN - Association of Women's Health, Obstetric, and Neonatal Nurses",
                "is_system_course_category": null
            },
            {
                "course_category_id": "1F4B1A8B-1EC9-E511-8771-005056B104B1",
                "course_category_name": "Nurse Midwife",
                "is_system_course_category": null
            },
            {
                "course_category_id": "33607431-5FF9-E611-B748-005056B122EA",
                "course_category_name": "Maternal Newborn",
                "is_system_course_category": null
            },
            {
                "course_category_id": "2FA45D8A-264F-DB11-9011-000423ACEF71",
                "course_category_name": "Obstetrics and Gynecology",
                "is_system_course_category": null
            },
            {
                "course_category_id": "43D048A0-1EC9-E511-8771-005056B104B1",
                "course_category_name": "Nurse",
                "is_system_course_category": null
            },
            {
                "course_category_id": "BF92C7B7-00C9-E511-BC00-005056B1263C",
                "course_category_name": "Ambulatory Care",
                "is_system_course_category": null
            },
            {
                "course_category_id": "4D1B82BB-02C9-E511-8771-005056B104B1",
                "course_category_name": "Acute Care Facility",
                "is_system_course_category": null
            },
            {
                "course_category_id": "4F027BAC-08C9-E511-8771-005056B104B1",
                "course_category_name": "Clinical Nurse Specialist",
                "is_system_course_category": null
            },
            {
                "course_category_id": "897AA72F-A78D-EB11-80DF-005056B1202E",
                "course_category_name": "AWHONN NOEP Library",
                "is_system_course_category": null
            },
            {
                "course_category_id": "F7C94142-A78D-EB11-80DF-005056B1202E",
                "course_category_name": "AWHONN - AWHONN NOEP Library (Resources in separate folder)",
                "is_system_course_category": null
            }
        ],
        "ce_accreditation": {
            "accrediting_body_name": "ANCC",
            "accreditation_statement": "",
            "course_level_accreditation_statement": "The Association of Women&rsquo;s Health, Obstetric and Neonatal Nurses is accredited as a provider of nursing continuing professional development by the American Nurses Credentialing Center&rsquo;s Commission on Accreditation. Accredited status does not imply endorsement by AWHONN or ANCC of any commercial products discussed/displayed in conjunction with the educational activity. AWHONN is approved by the California Board of Registered Nursing, Provider #CEP580",
            "credit_display_name": "ANCC CNE Credit",
            "credit_units": 2.5,
            "credit_unit_display_name": "ANCC Contact\r\nHour(s)"
        },
        "sub_courses": []
    },
    {
        "course_id": "06167229-5099-EB11-80E0-005056B1202E",
        "course_version": 4,
        "name": "AWHONN NOEP - Module 14 - Neonatal Procedures",
        "course_type": 1,
        "author_information": "The Neonatal Orientation and Education Program (NOEP) was published through the coordinated efforts of a team of dedicated AWHONN members and staff. Disclosures:\u202fNo commercial support or sponsorship was received for this presentation. The AWHONN nurse planner, contributors, and reviewers report no relevant financial or commercial conflicts related to this educational activity.",
        "description": "The purpose of this module is to provide an overview of common neonatal procedures. It begins with a review of general principles underlying all procedures, such as parental consent, and common risk factors, including pain, thermoregulation, and infection. Common nonivasive neonatal procedures such as car seat tolerance screening, critical congenital heart disease (CCHD) screening, and hearing screen will be reviewed. In addition, common invasive neonatal intensive care procedures, including IV insertion, venipuncture, capillary blood sampling, and bladder catheterization, will be reviewed. The module outlines the nurse\u2019s role in assisting with such procedures as umbilical artery catheter (UAC) and umbilical venous catheter (UVC) insertion, intubation, chest-tube insertion, and lumbar puncture. Lastly, information is provided on chest x-ray interpretation.",
        "learning_objectives_html": "At the completion of Module 14 the learner will be able to:\r\n<ul>\r\n    <li>Discuss the general principles underpinning neonatal procedures, including parental consent.</li>\r\n    <li>Describe common noninvasive procedures and invasive procedures along with their associated risks, precautions, and contraindications for each procedure.</li>\r\n    <li>Describe the fundamental steps in neonatal X-ray interpretation.<br />\r\n    <div>&nbsp;</div>\r\n    </li>\r\n</ul>",
        "course_outline_html": "Please refer to your administrator for course outlines.",
        "credit_info": "-",
        "categories": [
            {
                "course_category_id": "BF92C7B7-00C9-E511-BC00-005056B1263C",
                "course_category_name": "Ambulatory Care",
                "is_system_course_category": null
            },
            {
                "course_category_id": "1D5C5A97-08DB-E511-AA9E-005056B17E48",
                "course_category_name": "Women's Health",
                "is_system_course_category": null
            },
            {
                "course_category_id": "897AA72F-A78D-EB11-80DF-005056B1202E",
                "course_category_name": "AWHONN NOEP Library",
                "is_system_course_category": null
            },
            {
                "course_category_id": "4F027BAC-08C9-E511-8771-005056B104B1",
                "course_category_name": "Clinical Nurse Specialist",
                "is_system_course_category": null
            },
            {
                "course_category_id": "EE2F1978-C2F1-E311-941D-005056B1522B",
                "course_category_name": "AWHONN - Association of Women's Health, Obstetric, and Neonatal Nurses",
                "is_system_course_category": null
            },
            {
                "course_category_id": "E24BC24C-40B4-DF11-9F38-0015171C5BB1",
                "course_category_name": "CNE - Continuing Nurse Education",
                "is_system_course_category": null
            },
            {
                "course_category_id": "2FA45D8A-264F-DB11-9011-000423ACEF71",
                "course_category_name": "Obstetrics and Gynecology",
                "is_system_course_category": null
            },
            {
                "course_category_id": "33607431-5FF9-E611-B748-005056B122EA",
                "course_category_name": "Maternal Newborn",
                "is_system_course_category": null
            },
            {
                "course_category_id": "F7C94142-A78D-EB11-80DF-005056B1202E",
                "course_category_name": "AWHONN - AWHONN NOEP Library (Resources in separate folder)",
                "is_system_course_category": null
            },
            {
                "course_category_id": "1F4B1A8B-1EC9-E511-8771-005056B104B1",
                "course_category_name": "Nurse Midwife",
                "is_system_course_category": null
            },
            {
                "course_category_id": "43D048A0-1EC9-E511-8771-005056B104B1",
                "course_category_name": "Nurse",
                "is_system_course_category": null
            },
            {
                "course_category_id": "4D1B82BB-02C9-E511-8771-005056B104B1",
                "course_category_name": "Acute Care Facility",
                "is_system_course_category": null
            },
            {
                "course_category_id": "0DFB1B0D-04C9-E511-8771-005056B104B1",
                "course_category_name": "Allied Health Professional",
                "is_system_course_category": null
            }
        ],
        "ce_accreditation": {
            "accrediting_body_name": "ANCC",
            "accreditation_statement": "",
            "course_level_accreditation_statement": "The Association of Women&rsquo;s Health, Obstetric and Neonatal Nurses is accredited as a provider of nursing continuing professional development by the American Nurses Credentialing Center&rsquo;s Commission on Accreditation. Accredited status does not imply endorsement by AWHONN or ANCC of any commercial products discussed/displayed in conjunction with the educational activity. AWHONN is approved by the California Board of Registered Nursing, Provider #CEP580.",
            "credit_display_name": "ANCC CNE Credit",
            "credit_units": 2.75,
            "credit_unit_display_name": "ANCC Contact\r\nHour(s)"
        },
        "sub_courses": []
    },
    {
        "course_id": "00F2F145-4A99-EB11-80E0-005056B1202E",
        "course_version": 4,
        "name": "AWHONN NOEP - Module 15 - Developmental Care and Management of Pain and Stress",
        "course_type": 1,
        "author_information": "The Neonatal Orientation and Education Program (NOEP) was published through the coordinated efforts of a team of dedicated AWHONN members and staff. Disclosures:\u202fNo commercial support or sponsorship was received for this presentation. The AWHONN nurse planner, contributors, and reviewers report no relevant financial or commercial conflicts related to this educational activity.",
        "description": "This module will review sensory stimuli and discuss how it affects the developing newborn. The synactive theory of development and maturation of the sensory systems will be discussed as a foundation for understanding the unique needs of this population. The concept of individualized, family-centered developmental care will be introduced along with intervention strategies for caregivers. \r\nFinally, this module addresses the of pain and stress in newborns as well as providing both pharmacologic and nonpharmacologic management strategies. Special considerations regarding the substance exposed newborn and palliative care will also be discussed.",
        "learning_objectives_html": "At the completion of Module 15 the learner will be able to:\r\n<ul>\r\n    <li>Define the synactive theory of development.</li>\r\n    <li>Discuss the maturation of the senses from the fetal to newborn periods and the impact of the environment.</li>\r\n    <li>Describe interventions to support the seven core measures for neuroprotective, family-centered, developmental care.</li>\r\n    <li>Compare and contrast pain scoring tools for newborns.</li>\r\n    <li>Describe nonpharmacologic and pharmacologic approaches for managing pain in newborns.<br />\r\n    <div>&nbsp;</div>\r\n    </li>\r\n</ul>",
        "course_outline_html": "Please refer to your administrator for course outlines.",
        "credit_info": "-",
        "categories": [
            {
                "course_category_id": "1D5C5A97-08DB-E511-AA9E-005056B17E48",
                "course_category_name": "Women's Health",
                "is_system_course_category": null
            },
            {
                "course_category_id": "43D048A0-1EC9-E511-8771-005056B104B1",
                "course_category_name": "Nurse",
                "is_system_course_category": null
            },
            {
                "course_category_id": "4D1B82BB-02C9-E511-8771-005056B104B1",
                "course_category_name": "Acute Care Facility",
                "is_system_course_category": null
            },
            {
                "course_category_id": "80F07F74-26FE-E611-A7FF-005056B16BE3",
                "course_category_name": "Neonatal Disorders",
                "is_system_course_category": null
            },
            {
                "course_category_id": "0DFB1B0D-04C9-E511-8771-005056B104B1",
                "course_category_name": "Allied Health Professional",
                "is_system_course_category": null
            },
            {
                "course_category_id": "1F4B1A8B-1EC9-E511-8771-005056B104B1",
                "course_category_name": "Nurse Midwife",
                "is_system_course_category": null
            },
            {
                "course_category_id": "E24BC24C-40B4-DF11-9F38-0015171C5BB1",
                "course_category_name": "CNE - Continuing Nurse Education",
                "is_system_course_category": null
            },
            {
                "course_category_id": "2FA45D8A-264F-DB11-9011-000423ACEF71",
                "course_category_name": "Obstetrics and Gynecology",
                "is_system_course_category": null
            },
            {
                "course_category_id": "F7C94142-A78D-EB11-80DF-005056B1202E",
                "course_category_name": "AWHONN - AWHONN NOEP Library (Resources in separate folder)",
                "is_system_course_category": null
            },
            {
                "course_category_id": "33607431-5FF9-E611-B748-005056B122EA",
                "course_category_name": "Maternal Newborn",
                "is_system_course_category": null
            },
            {
                "course_category_id": "BF92C7B7-00C9-E511-BC00-005056B1263C",
                "course_category_name": "Ambulatory Care",
                "is_system_course_category": null
            },
            {
                "course_category_id": "EE2F1978-C2F1-E311-941D-005056B1522B",
                "course_category_name": "AWHONN - Association of Women's Health, Obstetric, and Neonatal Nurses",
                "is_system_course_category": null
            },
            {
                "course_category_id": "6C3323AC-E357-DB11-A8F9-000423ACEF71",
                "course_category_name": "Pain Management",
                "is_system_course_category": null
            },
            {
                "course_category_id": "897AA72F-A78D-EB11-80DF-005056B1202E",
                "course_category_name": "AWHONN NOEP Library",
                "is_system_course_category": null
            },
            {
                "course_category_id": "4F027BAC-08C9-E511-8771-005056B104B1",
                "course_category_name": "Clinical Nurse Specialist",
                "is_system_course_category": null
            }
        ],
        "ce_accreditation": {
            "accrediting_body_name": "ANCC",
            "accreditation_statement": "",
            "course_level_accreditation_statement": "The Association of Women&rsquo;s Health, Obstetric and Neonatal Nurses is accredited as a provider of nursing continuing professional development by the American Nurses Credentialing Center&rsquo;s Commission on Accreditation. Accredited status does not imply endorsement by AWHONN or ANCC of any commercial products discussed/displayed in conjunction with the educational activity. AWHONN is approved by the California Board of Registered Nursing, Provider #CEP580<br />\r\n<div>&nbsp;</div>",
            "credit_display_name": "ANCC CNE Credit",
            "credit_units": 2.25,
            "credit_unit_display_name": "ANCC Contact\r\nHour(s)"
        },
        "sub_courses": []
    },
    {
        "course_id": "018A58EA-4899-EB11-80E0-005056B1202E",
        "course_version": 4,
        "name": "AWHONN NOEP - Module 16 - Genetic Disorders and Congenital Anomalies",
        "course_type": 1,
        "author_information": "The Neonatal Orientation and Education Program (NOEP) was published through the coordinated efforts of a team of dedicated AWHONN members and staff. Disclosures:\u202fNo commercial support or sponsorship was received for this presentation. The AWHONN nurse planner, contributors, and reviewers report no relevant financial or commercial conflicts related to this educational activity.",
        "description": "The neonate with a genetic defect or fetal anomalies presents a challenge to the neonatal intensive care unit (NICU) team. Congenital malformations commonly have multiple factors and causes. The purpose of this module is to provide information on basic genetics, classifications of common genetic disorders, and fetal congenital anomalies. A systematic approach to evaluating a malformed neonate and common issues related to patient care management and the family\u2019s individualized care management will be reviewed.",
        "learning_objectives_html": "At the completion of Module 16 the learner will be able to:\r\n<ul>\r\n    <li>Examine the various definitions and classifications of genetic disorders and congenital anomalies.</li>\r\n    <li>Investigate the clinical presentation, diagnostic testing, and management of newborns with various types of anomalies.<br />\r\n    <div>&nbsp;</div>\r\n    </li>\r\n</ul>",
        "course_outline_html": "Please refer to your administrator for course outlines.",
        "credit_info": "-",
        "categories": [
            {
                "course_category_id": "33607431-5FF9-E611-B748-005056B122EA",
                "course_category_name": "Maternal Newborn",
                "is_system_course_category": null
            },
            {
                "course_category_id": "1F4B1A8B-1EC9-E511-8771-005056B104B1",
                "course_category_name": "Nurse Midwife",
                "is_system_course_category": null
            },
            {
                "course_category_id": "1D5C5A97-08DB-E511-AA9E-005056B17E48",
                "course_category_name": "Women's Health",
                "is_system_course_category": null
            },
            {
                "course_category_id": "E24BC24C-40B4-DF11-9F38-0015171C5BB1",
                "course_category_name": "CNE - Continuing Nurse Education",
                "is_system_course_category": null
            },
            {
                "course_category_id": "80F07F74-26FE-E611-A7FF-005056B16BE3",
                "course_category_name": "Neonatal Disorders",
                "is_system_course_category": null
            },
            {
                "course_category_id": "BF92C7B7-00C9-E511-BC00-005056B1263C",
                "course_category_name": "Ambulatory Care",
                "is_system_course_category": null
            },
            {
                "course_category_id": "EE2F1978-C2F1-E311-941D-005056B1522B",
                "course_category_name": "AWHONN - Association of Women's Health, Obstetric, and Neonatal Nurses",
                "is_system_course_category": null
            },
            {
                "course_category_id": "436FCBD1-1FFE-E611-A7FF-005056B16BE3",
                "course_category_name": "Genetic Disorders",
                "is_system_course_category": null
            },
            {
                "course_category_id": "4F027BAC-08C9-E511-8771-005056B104B1",
                "course_category_name": "Clinical Nurse Specialist",
                "is_system_course_category": null
            },
            {
                "course_category_id": "4D1B82BB-02C9-E511-8771-005056B104B1",
                "course_category_name": "Acute Care Facility",
                "is_system_course_category": null
            },
            {
                "course_category_id": "43D048A0-1EC9-E511-8771-005056B104B1",
                "course_category_name": "Nurse",
                "is_system_course_category": null
            },
            {
                "course_category_id": "897AA72F-A78D-EB11-80DF-005056B1202E",
                "course_category_name": "AWHONN NOEP Library",
                "is_system_course_category": null
            },
            {
                "course_category_id": "0DFB1B0D-04C9-E511-8771-005056B104B1",
                "course_category_name": "Allied Health Professional",
                "is_system_course_category": null
            },
            {
                "course_category_id": "F7C94142-A78D-EB11-80DF-005056B1202E",
                "course_category_name": "AWHONN - AWHONN NOEP Library (Resources in separate folder)",
                "is_system_course_category": null
            },
            {
                "course_category_id": "2FA45D8A-264F-DB11-9011-000423ACEF71",
                "course_category_name": "Obstetrics and Gynecology",
                "is_system_course_category": null
            }
        ],
        "ce_accreditation": {
            "accrediting_body_name": "ANCC",
            "accreditation_statement": "",
            "course_level_accreditation_statement": "The Association of Women&rsquo;s Health, Obstetric and Neonatal Nurses is accredited as a provider of nursing continuing professional development by the American Nurses Credentialing Center&rsquo;s Commission on Accreditation. Accredited status does not imply endorsement by AWHONN or ANCC of any commercial products discussed/displayed in conjunction with the educational activity. AWHONN is approved by the California Board of Registered Nursing, Provider #CEP580.",
            "credit_display_name": "ANCC CNE Credit",
            "credit_units": 2.25,
            "credit_unit_display_name": "ANCC Contact\r\nHour(s)"
        },
        "sub_courses": []
    }
];